import React from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import './App.css';
import { PrivateRoute, ProvideAuth } from './other/auth';

import AccountInfo from './components/AccountInfo';
import Login from './components/Login';
import MainMenu from './components/MainMenu/MainMenu';
import NavBar from './components/NavBar';

import EpgFullListing from './components/Epg-Fullscreen/EpgFullListing';
import Groups from './components/Group/Groups';
import MainLive from './components/Live/MainLive';
import Search from './components/Search/Search';

import MainVod from './components/Vod/MainVod';

import { useDispatch } from 'react-redux';
import { setTimer5 } from './actions/timer5';
import { setTimer60 } from './actions/timer60';

function App() {
  const dispatch = useDispatch();
  setInterval(() => dispatch(setTimer60()), 50000);
  setInterval(() => dispatch(setTimer5()), 5000);

  let url = window.location.pathname + window.location.search;

  return (
    <ProvideAuth>
      <Router>
        <Switch>
          <Route>
            <Route path="/:playingMode/">
              <NavBar />
            </Route>
            <PrivateRoute exact path="/">
              <MainMenu />
            </PrivateRoute>

            <Switch>
              <PrivateRoute exact path="/live/category/">
                <Groups />
              </PrivateRoute>
              <PrivateRoute exact path="/movie/category/">
                <Groups />
              </PrivateRoute>
              <PrivateRoute exact path="/series/category/">
                <Groups />
              </PrivateRoute>
              <PrivateRoute
                exact
                path="/:playingMode/category/:category/"></PrivateRoute>
            </Switch>

            <Switch>
              <PrivateRoute
                exact
                path="/:playingMode/category/:category/search/">
                <Search />
              </PrivateRoute>
              <PrivateRoute exact path="/:playingMode/search/">
                <Search />
              </PrivateRoute>
            </Switch>
            <Switch>
              <PrivateRoute exact path="/live/category/:category/tvguide/">
                <EpgFullListing />
              </PrivateRoute>
              <PrivateRoute exact path="/live/category/:category/tvguide/:date">
                <EpgFullListing />
              </PrivateRoute>
            </Switch>

            <Switch>
              <Route path="/login/">
                <Login url={url} />
              </Route>
              <PrivateRoute exact path="/info/">
                <AccountInfo />
              </PrivateRoute>
              <PrivateRoute path="/live/category/:category">
                <MainLive />
              </PrivateRoute>
              <PrivateRoute path="/live/">
                <MainLive />
              </PrivateRoute>
              <PrivateRoute path="/:playingMode/category/:category">
                <MainVod />
              </PrivateRoute>
              <PrivateRoute path="/:playingMode/">
                <MainVod />
              </PrivateRoute>
            </Switch>
          </Route>
        </Switch>
      </Router>
    </ProvideAuth>
  );
}

export default App;
